import React from 'react';
import { CheckCircle2Icon, LockKeyholeIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { heroHighlights, PRODUCT_IMAGE } from '../data/landing';
const trustSignals = [{
  icon: LockKeyholeIcon,
  label: 'Secure payment'
}, {
  icon: ZapIcon,
  label: 'Instant access'
}, {
  icon: ShieldCheckIcon,
  label: '7-day guarantee'
}];
export function HeroSection() {
  return <section className="bg-night px-5 py-6 sm:py-16" data-id="element-90" data-mp="2wjyyn08rqv3k">
      <div className="mx-auto grid max-w-6xl items-center gap-10 lg:grid-cols-[1.05fr_.95fr] lg:gap-14" data-id="element-91" data-mp="2wkijaopszxla">
        <div className="text-center lg:text-left" data-id="element-92" data-mp="30new1ysnwzhb">
          <p className="mb-3 inline-flex items-center gap-2 rounded-full border border-gold/40 bg-gold/10 px-3 py-1.5 text-[9px] font-bold uppercase tracking-[.14em] text-gold sm:mb-5 sm:px-4 sm:py-2 sm:text-[11px]" data-id="element-93" data-mp="2mup83otkpkhk">
            <span className="h-1.5 w-1.5 rounded-full bg-gold sm:h-2 sm:w-2" data-id="element-94" data-mp="3fht8thlmvcnj" />
            The #1 planning system for tennis coaches
          </p>
          <h1 className="font-display text-4xl font-bold uppercase leading-[.91] tracking-tight text-white sm:text-6xl md:text-7xl" data-id="element-95" data-mp="2ffiarq9wx1og">
            Plan your entire Tennis Season{' '}
            <span className="text-gold" data-id="element-96" data-mp="2bbu4dax0oc4s">in under 5 minutes.</span>
          </h1>

          <div className="mx-auto mt-4 w-full max-w-[440px] lg:hidden" data-id="element-97" data-mp="2p6wgifsgixq1">
            <img src={PRODUCT_IMAGE} alt="TENNIS READY complete coaching suite: six volumes, digital session plans and five bonus booklets" width={1536} height={1024} fetchPriority="high" className="w-full object-contain drop-shadow-2xl" data-id="element-98" data-mp="2kdk5x9km4rga" />
          </div>

          <p className="mx-auto mt-4 max-w-xl text-sm font-medium leading-relaxed text-slate-300 sm:text-lg lg:mx-0 lg:mt-6 lg:text-base" data-id="element-99" data-mp="381tnu0epgv25">
            TENNIS READY™ is your complete 6-in-1 coaching box set: 360+
            ready-to-run sessions, professional drills, tactical games and
            academy planning tools. All done for you.
          </p>
          <ul className="mx-auto mt-4 flex max-w-xl flex-wrap justify-center gap-x-3 gap-y-1.5 text-[11px] font-semibold text-white sm:gap-x-5 sm:gap-y-2 sm:text-sm lg:mx-0 lg:mt-6 lg:justify-start" data-id="element-100" data-mp="38uctykbay1hb">
            {heroHighlights.map(item => <li key={item} className="flex items-center gap-1 whitespace-nowrap" data-id="element-101" data-mp="3itvdiznavl8u">
                <CheckCircle2Icon className="h-3.5 w-3.5 shrink-0 text-gold sm:h-4 sm:w-4" data-id="element-102" data-mp="3mqzsgriwkzpc" />
                {item}
              </li>)}
          </ul>
          <a href="#offer-details" className="cta-button mt-5 inline-flex w-full items-center justify-center rounded-2xl px-6 py-6 text-xl font-bold sm:text-2xl lg:mt-8 lg:w-auto" data-id="element-103" data-mp="kulei7mxxj9">
            GET TENNIS READY™ NOW
          </a>
          <div className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-night-muted lg:mt-6 lg:justify-start" data-id="element-104" data-mp="edkhxgksikum">
            {trustSignals.map(({
            icon: Icon,
            label
          }) => <span key={label} className="flex items-center gap-1.5" data-id="element-105" data-mp="23u6d9qk1yxhp">
                <Icon className="h-4 w-4 text-gold" data-id="element-106" data-mp="23s1wi8122400" />
                {label}
              </span>)}
          </div>
        </div>

        <div className="relative mx-auto hidden w-[124%] max-w-none lg:block" data-id="element-107" data-mp="1usydf41w1oli">
          <div data-id="element-108" data-mp="1puwt6fsq7j8g">
            <img src={PRODUCT_IMAGE} alt="TENNIS READY complete coaching suite: six volumes, digital session plans and five bonus booklets" width={1536} height={1024} fetchPriority="high" className="w-full object-contain drop-shadow-2xl" data-id="element-109" data-mp="1pvez6456xbtk" />
          </div>
          <p className="mx-auto mt-4 w-fit border border-gold/30 bg-ink-mid px-4 py-2 text-center text-xs font-bold uppercase tracking-widest text-gold" data-id="element-110" data-mp="2dqhp6ffqdlbm">
            Your season, fully mapped out
          </p>
        </div>
      </div>
    </section>;
}